import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getProjectKeywords } from '../../../../services/monitor/keywords/KeywordsService';
import { KeywordResponse } from '../../../../models/monitor/KeywordResponse';
import { GET_PROJECT_KEYWORDS } from '../../../query/keyword/keys';

export const useGetProjectKeywords = (projectId: number | null) => {
  const queryClient = useQueryClient();
  const queryEnabled = !!projectId;

  const {
    data: keywords,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery<KeywordResponse[]>({
    queryKey: [GET_PROJECT_KEYWORDS, projectId],
    queryFn: () => getProjectKeywords(projectId!),
    staleTime: 0,
    gcTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    enabled: queryEnabled,
    retry: 3,
    retryDelay: 1000,
  });

  const invalidate = () =>
    queryClient.invalidateQueries({
      queryKey: [GET_PROJECT_KEYWORDS, projectId],
      refetchType: 'active',
    });

  return {
    keywords: queryEnabled ? keywords ?? [] : [],
    isLoading: queryEnabled ? isLoading : false,
    isError: queryEnabled ? isError : false,
    error: queryEnabled ? error : null,
    refetch,
    invalidate,
  };
};